export const CREATOR_TOASTS = {
  APPROVED: 'Creator approved',
  REJECTED: 'Creator rejected',
  DEADLINE_UPDATED: 'Deadline updated',
  DEADLINE_DELETED: 'Deadline deleted',
  SHIPPING_LINK_UPDATED: 'Shipping link updated',
  SHIPPING_LINK_DELETED: 'Shipping link removed',
  SHIPPING_LINK_ADDED: 'Shipping link added',
};
